import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CompanyBuyerConfigNotificationApi } from '../api/company-buyer-config-notification.api';

@Injectable({ providedIn: 'root' })
export class CompanyBuyerConfigNotificationService {
  private readonly _notificationApi = inject(CompanyBuyerConfigNotificationApi);

  public registerWebhook(buyerId: number, webhook: string): Observable<void> {
    return this._notificationApi.registerWebhook(buyerId, webhook);
  }

  public unsubscribe(buyerId: number): Observable<boolean> {
    return this._notificationApi.unsubscribe(buyerId);
  }
}
